



















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import TeamImage from '@/shared/components/ui/TeamImage.vue';
import AppModal from '@/shared/components/ui/Modal.vue';

@Component({
    components: {
        TeamImage,
        AppModal,
    },
})
export default class PlayerList extends Vue {
    @Prop() private availablePlayers: any;
    @Prop() private selectedPlayerType: any;
    @Prop() private playerTypes: any;
    @Prop() private playerTypeNames: any;
    @Prop() private lineUp: any;

    private search: string = '';

    private get players() {
        return this.availablePlayers.filter((p: any) => p.name.toLowerCase().includes(this.search.toLowerCase()));
    }

    private playerIsAligned(player: any) {
        return this.lineUp[0].find((x: any) => x.id === player.id) ||
            this.lineUp[1].find((x: any) => x.id === player.id) ||
            this.lineUp[2].find((x: any) => x.id === player.id) ||
            this.lineUp[3].find((x: any) => x.id === player.id) ||
            this.lineUp[4].find((x: any) => x.id === player.id);
    }

    private selectPlayer(player: any) {
        this.$emit('selectPlayer', player, true);
    }

    private close() {
        this.$emit('close');
    }

}
